import {Injectable} from '@angular/core';
import {IoService} from './io.service';
import {ContentBlock} from '../models';

@Injectable()
export class ContentBlockService extends IoService {
  protected model = ContentBlock;
  protected listUrl = '/content/';
}
